import { FC } from "react";
import Footer from "./Footer";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import SalonProfile from "./SalonProfile";
import Header from "./Header";
import { calendarSVG } from "../../../assets/SVGs/SVGs";
import { ConfigProvider, Empty, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { salonLocationBySlug } from "../../../network/clientSide";
// import { getLuminance } from "../../../utils/utils";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

interface ClientSideLayoutProps {}

const ClientSideLayout: FC<ClientSideLayoutProps> = ({}) => {
  const { currentLang } = useSelector((state: any) => state.user);
  const intl = useIntl();
  const navigate = useNavigate();
  const params = useParams();
  const url = window.location.href;

  const navigationCards = () => {
    if (
      url.includes("appointment") ||
      url.includes("gift-card") ||
      url.includes("membership")
    ) {
      return false;
    }
    return true;
  };
  const { salonSlug } = params;
  const { data: salonDetails, isLoading } = useQuery(
    ["salonDetails", salonSlug],
    () => salonLocationBySlug(salonSlug),
    {
      enabled: !!salonSlug,
      select: (res) => res?.data?.data?.location,
    }
  );

  const salon_brand_color_theme =
    salonDetails?.settings?.find(
      (item: any) => item?.key === "brand_color_theme"
    )?.value?.background_color || "#00086d";
  const salon_brand_color_txt =
    salonDetails?.settings?.find(
      (item: any) => item?.key === "brand_color_theme"
    )?.value?.primary_color || "#fff";

  // const luminance = getLuminance(salon_brand_color_theme);
  // const textColor = luminance > 128 ? "#00086d" : "#ffffff";

  document.documentElement.style.setProperty(
    "--salon-primary",
    salon_brand_color_theme
  );
  document.documentElement.style.setProperty(
    "--salon-secondary",
    salon_brand_color_txt
  );
  document.documentElement.style.setProperty(
    "--salon-primary-light",
    salon_brand_color_theme + "4d"
  );
  // document.documentElement.style.setProperty(
  //   "--salon-black-white-text",
  //   textColor
  // );
  return (
    <ConfigProvider
      theme={
        {
          token: {
            colorPrimary: salon_brand_color_theme,
            colorBtnColor: salon_brand_color_txt,
            colorTextDescription: salon_brand_color_theme,
            colorLink: salon_brand_color_theme,
            colorLinkHover: salon_brand_color_theme,
            colorPrimaryBorder: salon_brand_color_theme,
            colorPrimaryBgHover: salon_brand_color_theme + "4d",
            colorPrimaryHover: salon_brand_color_theme + "4d",
            defaultBg: salon_brand_color_theme + "4d",
          },
          components: {
            Button: {
              primaryColor: salon_brand_color_txt,
              colorTextLightSolid: salon_brand_color_txt,
            },
            Radio: {
              colorPrimary: salon_brand_color_theme,
            },
          },
        } as any
      }
    >
      <div
        dir={currentLang === "ar" ? "rtl" : "ltr"}
        // dir="rtl"
        className="relative min-h-screen flex flex-col justify-between  bg-white"
      >
        <Spin size="large" spinning={isLoading} className="min-h-screen">
          {salonDetails && !isLoading ? (
            <div className=" h-full w-screen  space-y-4">
              <Header />
              <div className=" container relative  min-h-[170px]  shadow-lg rounded-lg p-6 max-w-[1000px]  mx-auto">
                <SalonProfile salonDetails={salonDetails} />
                {navigationCards() ? (
                  <div className=" mt-[120px] md:mt-6 min-h-[250px] flex flex-col md:flex-row justify-between items-end gap-4 ">
                    <div
                      className="cursor-pointer h-[150px] text-center flex flex-col justify-center items-center p-2 bg-[#FBFBFF] rounded-lg w-full"
                      onClick={() => navigate(`appointment?catalog=all`)}
                    >
                      <p>{calendarSVG}</p>
                      <p className="tex-color-primary text-lg">
                        {intl.formatMessage({ id: "bookAppointment" })}
                      </p>
                      <p className="text-color-sec-title">
                        {intl.formatMessage({ id: "bookAppointmentDesc" })}
                      </p>
                    </div>

                    {/* <div
                className="cursor-pointer h-[150px] text-center flex flex-col justify-center items-center p-2 bg-[#FBFBFF] rounded-lg w-full"
                onClick={() => navigate(`gift-card?catalog=all`)}
              >
                <p>{giftCardSVG}</p>
                <p className="tex-color-primary text-lg">شراء كارت هدايا</p>
                <p className="text-color-sec-title">
                  قم بشراء كارت هدايا لأصدقاءك و عائلتك
                </p>
              </div> */}

                    {/* <div
                className="cursor-pointer h-[150px] text-center flex flex-col justify-center items-center p-2 bg-[#FBFBFF] rounded-lg w-full"
                onClick={() => navigate(`membership?catalog=all`)}
              >
                <p>{membershipCardSVG}</p>
                <p className="tex-color-primary text-lg">
                  الاشتراك في العضويات
                </p>
                <p className="text-color-sec-title">
                  قم بشراء عضوية في المشروع
                </p>
              </div> */}
                  </div>
                ) : null}
              </div>
              <div className="py-2 my-2   max-w-[1000px] mx-auto">
                <Outlet />
              </div>
            </div>
          ) : isLoading ? null : (
            <div className="py-2 my-2 h-[600px] flex justify-center items-center flex-col">
              <Empty description={false} />
              <h1 className="text-gray-500">هذا الرابط غير صالح</h1>
            </div>
          )}
        </Spin>
        <div className="mt-[200px]">
          <Footer />
        </div>
      </div>
    </ConfigProvider>
  );
};

export default ClientSideLayout;
